import React from "react";
import "../banner/bannerMain.css";
import "../../App.css";
import { Link } from "react-router-dom";
import { END_URL, IMG_URL } from "../../config.js";
import userImg from '../../images/user-ico.svg';
import setImg from '../../images/settin-ico.svg';
import prdtImg from '../../images/prdt-ico.svg';

function BannerMain({ data }) {
  const isLoading = !data || Object.keys(data).length === 0;

  // const isLoading = true;

  return (
    <section className="banner-wrapp">
      <div className="banner-col1">
        <div className="banner-img">
          {isLoading ? (
            <div className="skeleton skeleton-img"></div>
          ) : (
            <img src={`${IMG_URL}/public/${data.image}`} alt="banner" />
          )}
        </div>

        <div className="banner-col2">
        <div className="banner-text">
  {isLoading ? (
    <>
      <div className="skeleton skeleton-title"></div>
      <div className="skeleton skeleton-btn"></div>
    </>
  ) : (
    <>
      <h2 dangerouslySetInnerHTML={{ __html: data.title }} />
      <div className="pot-compt">
        <div
          className="pot-compt-card"
          dangerouslySetInnerHTML={{ __html: data.estimate1 }}
        ></div>
        <div
          dangerouslySetInnerHTML={{ __html: data.estimate2 }}
        ></div>
      </div>
    <Link to="/registerPage">
  <button className="banner-btn1">REGISTER YOUR CLAIM (FREE)</button>
</Link>

    </>
  )}
</div>


          <div className="banner-box1">
            {[1, 2, 3].map((_, index) => (
              <div key={index} className="banner-card">
                {isLoading ? (
                  <>
                    <div className="skeleton skeleton-head"></div>
                    <div className="skeleton skeleton-text"></div>
                  </>
                ) : (
                  <>
                    {index === 0 && (
                      <>
                        <div className="card-head">
                          <h5><span><img src={userImg} alt="" /></span> {data.subcontent}</h5>
                        </div>
                        <div className="card-cont">
                          <h3>{data.subtitle}</h3>
                          <p>{data.buttonlink}</p>
                        </div>
                      </>
                    )}

                    {index === 1 && (
                      <>
                        <div className="card-head">
                          <h5><span><img src={setImg} alt="" /></span> {data.buttonname}</h5>
                        </div>
                        <div className="card-cont">
                          <ol>
                            <li
                              className="price-regular"
                              dangerouslySetInnerHTML={{
                                __html: data.secondcount || "",
                              }}
                            ></li>
                            <li
                              className="price-spike"
                              dangerouslySetInnerHTML={{
                                __html: data.thirdcount || "",
                              }}
                            ></li>
                            <li
                              className="price-final"
                              dangerouslySetInnerHTML={{
                                __html: data.marqueecontent || "",
                              }}
                            ></li>
                          </ol>
                        </div>
                      </>
                    )}

                    {index === 2 && (
                      <>
                        <div className="card-head">
                          <h5><span><img src={prdtImg} alt="" /></span> {data.section1}</h5>
                        </div>
                        <div className="card-cont">
                          <ul
                            dangerouslySetInnerHTML={{
                              __html: data.section2 || "",
                            }}
                          ></ul>
                          <a href="#" className="read-more">
                            {data.section3}
                          </a>
                        </div>
                      </>
                    )}
                  </>
                )}
              </div>
            ))}
          </div>

          <div className="banner-ticker">
            {isLoading ? (
              <div className="skeleton skeleton-ticker"></div>
            ) : (
              <div className="ban-ticker-wrap">
                <div
                  className="ban-tick-item"
                  dangerouslySetInnerHTML={{
                    __html: data.firstcount || "",
                  }}
                ></div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

export default BannerMain;
